import React, { useState, useEffect } from "react";
import { Modal, Tooltip, Form, Input, message, Button } from "antd";
import { useWaitListStore } from "@/hooks/useWaitListInfoStore";
import {
  HeadBilingIcon,
  CopyIcon,
  EmailBorderIcon,
  RightMarkIcon,
} from "@/components/icons";
import getEnv from "@/utils/getEnv";
import copyToClipboard from "@/utils/copyToClipboard";
import { emailInviteApi } from "@/api/waitList";
import { emailValidator } from "@/biz/validator";
import { useModalStore } from "@/hooks/useModalStore";
import { useTranslation } from "react-i18next";

interface Props {}

const WaitListShareModal: React.FC<Props> = ({}) => {
  const { t } = useTranslation();
  const { waitListInfo } = useWaitListStore();
  const { productCode } = waitListInfo || {};
  const { showShareProductCodeModal, setShareProductCodeModal } =
    useModalStore();

  const [productCodeList, setProductCodeList] = useState<any>([]);

  useEffect(() => {
    if (productCode) {
      setProductCodeList(productCode);
    }
  }, [productCode]);

  const shareLink =
    getEnv() === "development"
      ? `https://test.brand.ahacreator.com/signup`
      : `https://brand.ahacreator.com/signup`;

  const handleCopy = (item: {
    code: string;
    used: boolean;
    copyEd: boolean;
  }) => {
    copyToClipboard(`${shareLink}?productCode=${item?.code}`);
    const list = [...productCodeList]?.map((v: any) => {
      if (v.code === item.code) {
        return {
          ...v,
          copyEd: true,
        };
      } else {
        return v;
      }
    });
    setProductCodeList(list);
    setTimeout(() => {
      const list = [...productCodeList]?.map((v) => {
        return {
          ...v,
          copyEd: false,
        };
      });
      setProductCodeList(list);
    }, 3000);
  };

  const handleSendEmail = (item: {
    code: string;
    used: boolean;
    copyEd: boolean;
    showEmailInput: boolean;
  }) => {
    const list = [...productCodeList]?.map((v: any) => {
      if (v.code === item.code) {
        return {
          ...v,
          showEmailInput: true,
        };
      } else {
        return v;
      }
    });
    setProductCodeList(list);
  };
  const handleEmailChange = (item: any, value: string) => {
    const list = [...productCodeList]?.map((v: any) => {
      if (v.code === item.code) {
        return {
          ...v,
          email: value,
          emailError: emailValidator(value) ? "" : item?.emailError,
        };
      } else {
        return v;
      }
    });
    setProductCodeList(list);
  };

  const [emailLoading1, setEmailLoading1] = useState(false);
  const [emailLoading2, setEmailLoading2] = useState(false);
  const handleEmailConfirm = async (item: any, index: number) => {
    if (!item.email || !emailValidator(item.email)) {
      const list = [...productCodeList]?.map((v: any) => {
        if (v.code === item.code) {
          return {
            ...v,
            emailError: t("headChatBot:waitListShareModal.enterValidEmail"),
          };
        } else {
          return v;
        }
      });
      setProductCodeList(list);
      return;
    }
    try {
      index === 0 ? setEmailLoading1(true) : setEmailLoading2(true);
      await emailInviteApi({
        email: item.email,
        url: `${shareLink}?productCode=${item?.code}`,
      });
      message.success(t("headChatBot:waitListShareModal.invitationSent"));
      const list = [...productCodeList]?.map((v: any) => {
        if (v.code === item.code) {
          return {
            ...v,
            email: "",
            showEmailInput: false,
            emailError: "",
          };
        } else {
          return v;
        }
      });
      setProductCodeList(list);
    } catch (error) {
      message.error(`${error}`);
    } finally {
      index === 0 ? setEmailLoading1(false) : setEmailLoading2(false);
    }
  };

  return (
    <Modal
      open={showShareProductCodeModal}
      onCancel={() => setShareProductCodeModal(false)}
      footer={null}
      title=""
      width={540}
      closable={true}
      centered
      styles={{
        content: {
          borderRadius: "16px",
        },
      }}
    >
      <div className="flex justify-center items-center flex-col pt-[20px] pb-[30px]">
        <HeadBilingIcon className="w-[87px] h-[60px]" />
        <div className="self-stretch mt-8 inline-flex flex-col justify-start items-center gap-4">
                      <div className="justify-start text-[#1c2024] text-xl font-semibold  leading-relaxed">
              {t("headChatBot:waitListShareModal.title")}
            </div>
          <div className="justify-start">
                          <span className="text-[#171717] text-sm font-normal  leading-snug">
                {t("headChatBot:waitListShareModal.subtitle")}
              </span>
            <span className="text-[#171717] text-sm font-bold  leading-snug">
              $30
            </span>
                          <span className="text-[#171717] text-sm font-normal  leading-snug">
                {" "}
                {t("headChatBot:waitListShareModal.adCredits")}
              </span>
          </div>
        </div>
        <div className="mt-8 flex flex-col items-center">
          <div className="inline-flex justify-start items-start mb-2">
            <div className="w-[160px] h-12 px-3 py-px inline-flex flex-col justify-center items-start gap-2.5">
                              <div className="inline-flex justify-center items-center gap-2.5">
                  <div className="justify-start text-zinc-500 text-sm font-medium ">
                    {t("headChatBot:waitListShareModal.invitationCode")}
                  </div>
                </div>
            </div>
            <div className="w-[130px] h-12 px-3 py-px inline-flex flex-col justify-center items-start gap-2.5">
                              <div className="inline-flex justify-center items-center gap-2.5">
                  <div className="justify-start text-zinc-500 text-sm font-medium ">
                    {t("headChatBot:waitListShareModal.friendsInvited")}
                  </div>
                </div>
            </div>
            <div className="w-[120px] h-12 px-3 py-px flex justify-start items-center gap-0.5">
                              <div className="flex justify-center items-center gap-2.5">
                  <div className="justify-start text-zinc-500 text-sm font-medium ">
                    {t("headChatBot:waitListShareModal.share")}
                  </div>
                </div>
            </div>
          </div>
          {productCodeList?.map(
            (
              item: {
                code: string;
                used: boolean;
                copyEd: boolean;
                showEmailInput: boolean;
                emailError: string;
                email: string;
                emailLoading: boolean;
              },
              index: number
            ) => (
              <div
                className="border-b border-[#E4E4E7] w-[400px]"
                key={item?.code}
              >
                <div className="inline-flex justify-start items-center">
                  <div className="w-[160px] self-stretch p-3 inline-flex flex-col justify-center items-start gap-2.5">
                    <div className="self-stretch inline-flex justify-start items-center gap-2.5">
                      <div className="flex-1 justify-start text-zinc-950 text-sm font-medium ">
                        {item?.code}
                      </div>
                    </div>
                  </div>
                  <div className="w-[130px] self-stretch p-3 inline-flex flex-col justify-center items-start gap-2.5">
                    <div className="self-stretch inline-flex justify-start items-center gap-2.5">
                      <div className="flex-1 justify-start text-zinc-950 text-sm font-medium ">
                        {item?.used ? "1" : "0"}/1
                      </div>
                    </div>
                  </div>
                  <div className="w-[110px] self-stretch p-3 inline-flex flex-col justify-center items-start gap-2.5">
                    <div className="self-stretch inline-flex justify-start items-center gap-2.5">
                      <span
                        className="cursor-pointer"
                        onClick={() => handleSendEmail(item)}
                      >
                        <EmailBorderIcon
                          className={`${
                            item?.showEmailInput ? "text-[#FB6011]" : ""
                          }`}
                        />
                      </span>
                                              <Tooltip
                          title={`${t("headChatBot:waitListShareModal.tooltip")} ${shareLink}?productCode=${item?.code}`}
                        >
                        <span
                          className="cursor-pointer"
                          onClick={() => handleCopy(item)}
                        >
                          {item?.copyEd ? (
                            <RightMarkIcon className="w-[20px] h-[20px]" />
                          ) : (
                            <CopyIcon className="w-[20px] h-[20px]" />
                          )}
                        </span>
                      </Tooltip>
                    </div>
                  </div>
                </div>
                {item?.showEmailInput && (
                  <div className="mb-2 flex flex-col gap-2 w-full">
                    <div className="flex items-center w-full gap-2">
                      <Input
                        placeholder={t("headChatBot:waitListShareModal.placeholder")}
                        size="large"
                        className="w-full"
                        type="email"
                        value={item?.email}
                        onChange={(e: any) =>
                          handleEmailChange(item, e?.target?.value)
                        }
                      ></Input>
                      <Button
                        type="primary"
                        size="large"
                        loading={index === 0 ? emailLoading1 : emailLoading2}
                        onClick={() => handleEmailConfirm(item, index)}
                      >
                        {t("headChatBot:waitListShareModal.send")}
                      </Button>
                    </div>
                    <div className="text-[#7f1d1d] font-normal">
                      {item?.emailError}
                    </div>
                  </div>
                )}
              </div>
            )
          )}
        </div>
      </div>
    </Modal>
  );
};

export default WaitListShareModal;
